import { Badge } from "../ui/Badge.jsx";
import { Button } from "../ui/Button.jsx";
import { clamp, scrollToId } from "../utils.js";

function Stat({ value, label }) {
  return (
    <div className="stat" data-reveal>
      <div className="statValue">{value}</div>
      <div className="statLabel">{label}</div>
    </div>
  );
}

export function Hero() {
  return (
    <section className="hero">
      <div className="heroBg" aria-hidden="true">
        <div className="orb orbA" data-parallax="0.08" />
        <div className="orb orbB" data-parallax="0.12" />
        <div className="grid" data-parallax="0.05" />
        <div className="noise" />
      </div>

      <div className="container heroInner">
        <div className="heroLeft" data-reveal>
          <div className="kicker">
            <Badge>Buyrights ЛК</Badge>
            <span className="muted">Личный кабинет для авторов и нарушителей</span>
          </div>
          <h1 className="h1">
          Защитите свои авторские права
            <br />
            <span className="gradText">за 24 часа с вложениями 0 руб</span>
          </h1>
          <p className="lead">
             Юридическая помощь в любом регионе РФ
          </p>
          <div className="heroButtons">
            <Button onClick={() => scrollToId("cta")}>Найти нарушения</Button>
            <Button variant="secondary" onClick={() => scrollToId("effects")}>
              Создать личный кабинет
            </Button>
          </div>
          <div className="heroStats">
            <Stat value="100%" label="бесплатно" />
            <Stat value="0" label="ваших затрат времени" />
            <Stat value="₽" label="дополнительный заработок" />
          </div>
        </div>

        {/* <div className="heroRight" data-reveal>
          <div className="card heroCard">
            <div className="heroCardTop">
              <div className="pill">Сценарий</div>
              <div className="muted">Демо-поток</div>
            </div>
            <div className="timeline">
              {[
                { t: "Загрузка файла", s: "SHA-256 + метаданные" },
                { t: "Фиксация", s: "временная метка + журнал" },
                { t: "Мониторинг", s: "поиск совпадений" },
                { t: "Отчёт", s: "доказательная база" }
              ].map((row, i) => (
                <div
                  key={row.t}
                  className="timelineRow"
                  style={{ "--d": `${clamp(i * 90, 0, 360)}ms` }}
                  data-reveal
                >
                  <div className="dot" aria-hidden="true" />
                  <div className="timelineText">
                    <div className="timelineT">{row.t}</div>
                    <div className="timelineS muted">{row.s}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="heroCardBottom">
              <span className="muted">Плавная анимация + hover</span>
              <span className="chip" aria-hidden="true">
                live
              </span>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}

